<template>
  <section class="wrapper">
    <div class="logo"><img src="../../assets/img/wc-erp-logo.png" alt=""></div>
    <h1 class="title">登录网书智能ERP系统</h1>
    <van-tabs line-height="1" shrink>
      <van-tab title="账号密码登录">
        <van-form class="mt10" @submit="loginActivateUser">
          <van-field
            v-model="loginForm.loginName"
            label="用户名"
            placeholder="用户名"
            readonly
          />
          <van-field
            class="mt10"
            v-model="loginForm.pwd"
            type="password"
            name="密码"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
          <van-field
            class="mt10"
            v-model="loginForm.validateCode"
            name="验证码"
            label="验证码"
            placeholder="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
          >
            <template #button>
              <van-image width="56" :src="validateCodeImgUrl" @click="desCodeSend"/>
            </template>
          </van-field>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit">确认登录</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
  </section>
</template>

<script>
  import {getValidCodeFun, getValidateCodeFun,initUserCompanyApi} from '@/api/common'
  import {getActivateUser,loginActivateUser} from '@/api/login'
  import {getUrlParam} from "@/utils/utitiles"
  export default {
    name: "loginavite",
    data () {
      return {
        validateCodeImgUrl: '',//验证码图片地址
        loginForm: {
          guid:'',
          loginName: '',
          pwd: '',
          validateCode: '',
          dESEncryptValidCode: ''
        }
      };

    },
    mounted() {
      this.getLoginUser();
      this.desCodeSend();
    },
    methods: {
      async getLoginUser() {
        let guid = getUrlParam("guid");
        if (guid && guid != null && guid != "") {
          let params = {
            guid: guid
          };
          let response = await getActivateUser(params);
          if (response.success) {
            this.$set(this.loginForm, "guid", response.Guid);
            this.$set(this.loginForm, "loginName", response.LoginName);
          }
        }
      },
      //获取加密的验证码,有了这个码才可以请求图片验证码
      async desCodeSend() {
        let response = await getValidCodeFun();
        if (response.success) {
          this.loginForm.dESEncryptValidCode = response.result;
          this.getValidateCode(response.result)
        }
      },
      //获取验证码图片
      async getValidateCode(code) {
        const params = {
          code
        };
        let response = await getValidateCodeFun(params);
        if (response.success) {
          const bufferUrl = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          this.validateCodeImgUrl = 'data:image/png;base64,' + bufferUrl;
        }
      },
     //登录已激活用户
     async loginActivateUser() {
       let params = {
         ...this.loginForm
       };
       let response = await loginActivateUser(params);
       if (response.success) {
         if (response.code === '0000') {
           this.setCookie("UserInfo",{
             U_GUID:response.result.CurrentUserGuid,
             LoginName:response.result.LoginName,
             TelName:response.result.TelName,
             NickName:response.result.NickName,
             FirstName:response.result.FirstName,
             LastName:response.result.LastName
           });
           await this.selectCompany(response.result.CurrentUserGuid,response.result.CurrentCompanyGuid,response.result.LoginName,response.result.TelName);
           return;
         }
         this.$toast.fail(response.msg);
         await this.desCodeSend();
         return;
       }
     },
      //选择公司
      async selectCompany(uGuid, cGuid, loginName, telName) {
        let params = {
          cGuid: cGuid,
          uGuid: uGuid,
          userName: loginName || telName
        }
        let response = await initUserCompanyApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.setCookie("CompanyInfo", {
              companyId: response.result.C_GUID,
              companyName: response.result.Name || response.result.ChineseFullName,
              loginDate: response.loginDate,
              dateFormat:response.dateFormat,
              Currency:response.result.Currency,
              enterDate: this.moment(response.result.EnterDate).format('YYYY/MM/DD HH:mm:ss')+'(UTC+8)'
            });
            //判断是否有数据，如果有数据说明是有传参的
            if (this.loginInfo && this.loginInfo != null) {
              this.removeCookie('LoginInfo');
              //跳转到待审批页面
              this.$router.push({
                path: this.loginInfo.TargetUrl, query: {
                  guid: this.loginInfo.ApprovalGUID
                }
              });
              return;
            }
            this.$router.push({path: '/home'});
            return;
          } else {
            this.$toast.fail("公司初始化数据失败");
          }
        }
      }
    },
  }
</script>
<style lang="less" scoped>
  .wrapper {
    background: white;

    .logo {
      padding: 1rem;

      img {
        width: 70%;
      }
    }

    .title {
      text-align: center;
      padding: 2rem 0;
      background: white;
    }

    .info {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      font-size: 1.4rem;
      padding: 0 1rem;
      color: #ccc;
      height: 2rem;
      line-height: 2rem;

      .link {
        color: #00a1bb;
        display: inline-block;
      }
    }

    ::v-deep.van-tab--active {
      flex: .3;
    }

    ::v-deep.van-tabs__line {
      width: 6rem;
    }

    ::v-deep.van-button{
      background:#1fb1c4
    }
  }
</style>
